/*
 * RNR Digital Media Group
 * Libautech "Buy on Amazon" click tracking
 * Pushes a custom event into Google Tag Manager's dataLayer.
 */
(function () {
  'use strict';

  function cleanText(value) {
    return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : '';
  }

  function elementText(element) {
    return cleanText(
      (element && (element.innerText || element.textContent || element.getAttribute && element.getAttribute('aria-label'))) || ''
    );
  }

  function elementHref(element) {
    if (!element || !element.getAttribute) return '';
    return element.href || element.getAttribute('href') || element.getAttribute('data-href') || element.getAttribute('data-url') || '';
  }

  function isAmazonUrl(value) {
    return /(^|\.)amazon\.[a-z.]+(?:\/|$)|amzn\.to(?:\/|$)/i.test(value || '');
  }

  function isLibautechNode(element) {
    if (!element || element.nodeType !== 1) return false;
    var identity = [
      element.id,
      element.className && String(element.className),
      element.getAttribute && element.getAttribute('data-block-handle'),
      element.getAttribute && element.getAttribute('data-app')
    ].filter(Boolean).join(' ');
    return /libautech|amazon-buy-button/i.test(identity);
  }

  function selectedVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var params = new URLSearchParams(window.location.search);
    var variantId =
      params.get('variant') ||
      (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) ||
      '';
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || product.variants[0] || null;
  }

  document.addEventListener('click', function (event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    if (!path.length) {
      var current = event.target;
      while (current) {
        path.push(current);
        current = current.parentElement;
      }
    }

    var clicked = path.find(function (node) {
      return node && node.nodeType === 1 && node.matches && node.matches('a, button, [role="button"]');
    });
    if (!clicked) return;

    var href = elementHref(clicked);
    var label = elementText(clicked);
    var insideLibautech = path.some(isLibautechNode);
    var looksLikeAmazonButton = /buy\s+(on|at)\s+amazon/i.test(label) || isAmazonUrl(href);

    if (!insideLibautech || !looksLikeAmazonButton) return;

    var product =
      (window.meta && window.meta.product) ||
      (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) ||
      null;
    var variant = selectedVariant(product);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'buy_on_amazon_click',
      product_title: product && product.title ? product.title : cleanText(document.querySelector('h1') && document.querySelector('h1').textContent),
      product_id: product && product.id ? String(product.id) : '',
      product_sku: variant && variant.sku ? variant.sku : '',
      variant_id: variant && variant.id ? String(variant.id) : '',
      variant_title: variant && variant.title ? variant.title : '',
      amazon_url: href,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }, true);
})();